import { userBaseUrl } from "../api/Constants";
import createAxiosInstance from "../utils/apiUtils";
//import { LOCAL } from "../api/Constants";

const instance = createAxiosInstance({
	baseURL: userBaseUrl + "/bhph/autopay/",
	//baseURL: LOCAL + "/autopay/",
});

// List autopays for a given account
export const listAutoPaysByAccount = async (accountID) => {
	return await instance.get(`list/${accountID}`);
};

// Create a new autopay
export const createNewAutoPay = async (autopay) => {
	return await instance.post("new", autopay);
};

// Deactivate an existing autopay
export const deactivateAutoPay = async (autopayID) => {
	return await instance.get(`deactivate/${autopayID}`);
};

// Activate an existing autopay
export const activateAutoPay = async (autopayID) => {
	return await instance.get(`activate/${autopayID}`);
};

// Tokenize and add a card to an account
export const addCardToAccount = async (body) => {
	return await instance.post("add-card", body);
};

// Tokenize and add a bank account to an account
export const addBankToAccount = async (body) => {
	return await instance.post("add-bank", body);
};

// Set which DigitzsCustomer (card/bank) the autopay should use
export const setAutoPayPaymentMethod = async (autopayID, digitzsCustomerID) => {
	return await instance.get(
		`set-payment-method/${autopayID}/${digitzsCustomerID}`
	);
};

// List all payment methods (cards & banks) for an account
export const listPaymentMethods = async (accountID) => {
	return await instance.get(`list-payment-method/${accountID}`);
};

// List all past payments for an autopay
export const listPaymentHistory = async (autopayID) => {
	return await instance.get(`list-payment-history/${autopayID}`);
};

// List all future scheduled payments for an autopay
export const listScheduledPayments = async (autopayID) => {
	return await instance.get(`list-scheduled-payment/${autopayID}`);
};
// List all  scheduled payments for an autopay
export const listAllScheduledPayments = async (autopayID) => {
	return await instance.get(`list-scheduled-payment/${autopayID}`);
};

export const listAllScheduledPaymentsbydate = async (
	locationID,
	fromDate,
	toDate
) => {
	return await instance.get(
		`list-All-scheduled-payment-bydate/${locationID}?fromDate=${fromDate}&toDate=${toDate}`
	);
};
